import { z } from 'zod'
import { AGGREGATION_TYPES } from '@carto/kepler.gl/constants'

import { KeplerAggregationType } from 'features/builder/types'
import { isLatitude, isLongitude } from 'features/builder/utils/mapUtils'

export const KeplerAggregationTypeSchema = z.enum(Object.values(AGGREGATION_TYPES) as KeplerAggregationType[])

const PositionSchema = z.array(z.number()).length(2).or(z.array(z.number()).length(3))

export const GeoJSONPolygonSchema = z.object({
  type: z.literal('Polygon'),
  coordinates: z.array(z.array(PositionSchema))
})

export const GeoJSONMultiPolygonSchema = z.object({
  type: z.literal('MultiPolygon'),
  coordinates: z.array(z.array(z.array(PositionSchema)))
})

export const LatitudeSchema = z.number().refine(isLatitude, { message: 'Invalid latitude' })

export const LongitudeSchema = z.number().refine(isLongitude, { message: 'Invalid longitude' })
